import { Br } from "@/components/molecules/Br";
import Image from "next/image";
import coverCareers from "/public/cover-careers.webp";
import leadCareersS from "/public/lead-careersS.svg";

const CareerCover = () => {
  return (
    <>
      <div className="relative flex aspect-1.91/1 items-center justify-center">
        <div className="z-10 box-border flex h-3/4 w-[42.5%] flex-col items-start justify-center bg-white p-3 md:justify-center md:p-12">
          <h4 className="font-bold text-pri fluid-text-[14px,22px]">Careers</h4>
          <div className="mt-1 space-y-1 md:space-y-6">
            <h2 className="relative">
              <span className="hidden md:block">
                <Image
                  src={leadCareersS}
                  alt="ともに創ろう。"
                  quality={80}
                  width={240}
                  height={48}
                />
              </span>
              <span className="block md:hidden">
                <Image
                  src={leadCareersS}
                  alt="ともに創ろう。"
                  quality={80}
                  width={168}
                  height={40}
                />
              </span>
            </h2>
            <h5 className="font-bold leading-snug text-ter fluid-text-[12px,22px] md:leading-comfort">
              最高のサービスその先に、
              <Br tbpc />
              私たちの感動が待っています。
            </h5>
          </div>
        </div>
        <div className="z-0">
          <Image
            src={coverCareers}
            alt="【Voices: メンバーの声 No.2】 インタビューカット"
            quality={80}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
    </>
  );
};

export default CareerCover;
